import React, { useEffect, useState } from 'react';
import { Activity, CheckCircle2, Timer, Undo2 } from 'lucide-react';
import { agentApi } from '../agentApi';
import { PMS_DATA_DOMAINS, usePmsDataRefresh } from '../dataSync';
import { formatMinutes } from '../format';

function StatsStrip({ scope, refreshKey }) {
  const [stats, setStats] = useState(null);
  const [agentChanges, setAgentChanges] = useState(0);
  usePmsDataRefresh(PMS_DATA_DOMAINS, () => setAgentChanges((count) => count + 1), { delayMs: 1500 });

  useEffect(() => {
    let cancelled = false;
    agentApi
      .stats(scope)
      .then((data) => !cancelled && setStats(data))
      .catch(() => !cancelled && setStats(null));
    return () => {
      cancelled = true;
    };
  }, [scope, refreshKey, agentChanges]);

  const tiles = [
    { icon: Timer, label: 'Desk time covered', value: stats ? formatMinutes(stats.manualMinutes) : '—', accent: true },
    { icon: Activity, label: 'Agent runs', value: stats ? stats.runs : '—' },
    { icon: CheckCircle2, label: 'Actions executed', value: stats ? stats.actions?.SUCCEEDED || 0 : '—' },
    { icon: Undo2, label: 'Undone', value: stats ? stats.actions?.UNDONE || 0 : '—' },
  ];

  return (
    <div className="dagent-kpis" aria-label={`Last 30 days${scope === 'all' ? ', all staff' : ''}`}>
      {tiles.map(({ icon: Icon, label, value, accent }) => (
        <div key={label} className={`dagent-kpi ${accent ? 'dagent-kpi--accent' : ''}`}>
          <Icon size={15} aria-hidden="true" />
          <div>
            <strong>{value}</strong>
            <span>{label}</span>
          </div>
        </div>
      ))}
      <span className="dagent-kpis__note">Last 30 days{scope === 'all' ? ' · all staff' : ''}</span>
    </div>
  );
}

export default StatsStrip;
